import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';


//Redux
import { useSelector, useDispatch } from "react-redux";
import { SET_CALCULATOR  } from '../../redux/actions/types';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(3),
  },
  margin: {
    height: theme.spacing(3),
  },
}));

const marks = [
  {
    value: 0,
    label: `₱ 500`,
    val: 500,
  },
  {
    value: 20,
    label: `₱ 1000`,
    val: 1000,
  },
  {
    value: 40,
    label: `₱ 1500`,
    val: 1500,
  },
  {
    value: 60,
    label: `₱ 2000`,
    val: 2000,
  },
  {
    value: 80,
    label: `₱ 2500`,
    val: 2500,
  },
  {
    value: 100,
    label: `₱ 3000`,
    val: 3000,

  },
];






export default function DiscreteSlider() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { calculator } = useSelector(state => state.data);
  const [values, setValues] = useState({
    value: 0,
    label: `₱ 500`,
    val: 500,
  });


  const valuetext = (value) => {
    let val = marks.find(a => a.value === value);
    if(val.value !== values.value){
    dispatch({type: SET_CALCULATOR , payload: 
      {principal: val.val}
    })
  }
    return val.val;
  }

  useEffect(() => {
    let vl = marks.find(a => a.val === calculator.principal);
    if(vl){
      setValues(vl);
    }

  }, [calculator.principal])

  return (
    <div className={classes.root}>
 
      <Slider
        defaultValue={values.value}
        getAriaValueText={valuetext}
        valueLabelFormat={valuetext}
        step={20}
        marks={marks}
        valueLabelDisplay="on"
      />
           <Typography className="text-center pt-2" color="primary">
        Loan Ammount
      </Typography>
    </div>
  );
}
